import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Input, message } from 'utils/ui';
import { sha512 } from 'hash-anything';
import { createUser, loginUser } from "../api_calls/user";
import NavViews from '../stores/NavViews';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';
import FormField from '../common/FormField';
import _ from "underscore";

@observer(["UserStore", "CustomRouter"])
class RegisterButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            password: "",
            confirmPassword: "",
            hashPass: "",
            family: "",
            registerModalIsOpen: false,
            loginModalIsOpen: false,
            forgotModalIsOpen: false,
            submitting: false,
            buttons: this.renderSignUpButton()
        };
       
        this.closeRegisterModal = this.closeRegisterModal.bind(this);
        this.onFamilyClick = this.onFamilyClick.bind(this);       
        this.submitRegister = this.submitRegister.bind(this);
        this.submitLogin = this.submitLogin.bind(this);
        this.handleEnterKey = this.handleEnterKey.bind(this);
    }

    renderSignUpButton() {
        return <div>
            <Button style={_.extend(this.props.style || {}, { marginLeft: "4px", backgroundColor: "#F6D55C", borderRadius: "40px", color: 'white', fontWeight: "bold" })} size="large" onClick={() => { this.setState({ registerModalIsOpen: true, loginModalIsOpen: false }) }}>Sign Up</Button>
        </div>;
    }

    closeRegisterModal() {
        this.setState({ registerModalIsOpen: false });
    }

    componentDidMount() {
        document.addEventListener("keyup", this.handleEnterKey);
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.handleEnterKey);
    }

    handleEnterKey(event) {
        if (event.key !== "Enter") return;
        if (this.state.registerModalIsOpen) {
            this.submitRegister();
        }
    }

    validateRegistration() {
        const email = (this.state.email || "").trim();
        const name = (this.state.name || "").trim();
        const password = this.state.password || "";
        const confirmPassword = this.state.confirmPassword || "";

        if (!name) {
            message.warning("Please enter your name.");
            return false;
        }

        if (!email) {
            message.warning("Please enter your email.");
            return false;
        }

        if (!/^\S+@\S+\.\S+$/.test(email)) {
            message.warning("Please enter a valid email address.");
            return false;
        }

        if (!password) {
            message.warning("Please enter a password.");
            return false;
        }

        if (password.length < 8) {
            message.warning("Password must be at least 8 characters long.");
            return false;
        }

        if (password !== confirmPassword) {
            message.warning("Passwords do not match.");
            return false;
        }

        return true;
    }

    async submitLogin() {
        const { UserStore } = this.props;
        let email = (this.state.email || "").trim();
        let passHash = this.state.hashPass;
        if (email === "") {
            message.warning("Please enter your email.");
            this.setState({ submitting: false });
            return false;
        } else if (passHash === "") {
            message.warning("Please enter a password.");
            this.setState({ submitting: false });
            return false;
        }

        const response = await loginUser(email, passHash);

        if (!response || !response.success) {
            if (response && (response.status === 401 || response.status === 403)) {
                message.error("Email or password does not match database.");
            } else {
                message.error("Unable to log in right now. Please try again.");
            }
            this.setState({ submitting: false });
            return false;
        }

        let inviteId = this.props.CustomRouter && this.props.CustomRouter.router.params && this.props.CustomRouter.router.params.inviteId;
        const user = await UserStore.handleLoggedIn(response.data, inviteId);

        if (user && user.groups && user.groups.length === 0) {
            message.info("You're in! Next step: create your first group.");
            this.props.CustomRouter.router.goTo(NavViews.groups);
        }

        this.setState({
            registerModalIsOpen: false,
            loginModalIsOpen: false,
            submitting: false
        });
        return true;
    }

    async submitRegister() {
        let self = this;
        if (this.state.submitting) {
            return;
        }

        if (!this.validateRegistration()) {
            return;
        }

        this.setState({ submitting: true });
        const response = await createUser(
            this.state.name.trim(),
            this.state.email.trim(),
            this.state.hashPass,
            this.state.family
        );

        if (response && response.success) {
            self.submitLogin();
            return;
        }

        this.setState({
            submitting: false,
            buttons: self.renderSignUpButton()
        });
    }
    onFamilyClick(event) {
        this.setState({ family: event.key });
    }

    render() {
        return (
            <div>
                <ModalShell
                    isOpen={this.state.registerModalIsOpen}
                    onRequestClose={this.closeRegisterModal}
                    contentLabel="Register Modal"
                    className="register-modal"
                    overlayClassName="register-modal-overlay"
                    maxWidth={420}>
                    <ModalBody title="Sign Up" subtitle="Create your account">
                        <div className="AppFont" style={{ color: '#222' }}>
                            <FormField label="Name" style={{ marginBottom: '1rem' }}>
                                <Input
                                    placeholder="Enter your name"
                                    value={this.state.name}
                                    onChange={(e) => { this.setState({ name: e.target.value }) }}
                                />
                            </FormField>

                            <FormField label="Email" style={{ marginBottom: '1rem' }}>
                                <Input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={this.state.email}
                                    onChange={(e) => { this.setState({ email: e.target.value }) }}
                                />
                            </FormField>

                            <FormField label="Password" style={{ marginBottom: '1rem' }}>
                                <Input
                                    id="password-register"
                                    type="password"
                                    placeholder="Create a password (8+ characters)"
                                    value={this.state.password}
                                    onChange={(e) => {
                                        const password = e.target.value;
                                        this.setState({
                                            password,
                                            hashPass: sha512(password)
                                        });
                                    }}
                                />
                            </FormField>

                            <FormField label="Confirm Password" style={{ marginBottom: '1rem' }}>
                                <Input
                                    type="password"
                                    placeholder="Re-enter your password"
                                    value={this.state.confirmPassword}
                                    onChange={(e) => { this.setState({ confirmPassword: e.target.value }) }}
                                />
                            </FormField>

                            <Button
                                className="btn-submit ui-btn-success"
                                id="submitBtn-register"
                                onClick={this.submitRegister}
                                disabled={this.state.submitting}
                                style={{ width: '100%', borderRadius: '20px', height: '40px', color: '#3A3A3A', fontWeight: 'bold', fontSize: '16px' }}
                            >
                                {this.state.submitting ? "Creating Account..." : "Create Account"}
                            </Button>
                        </div>
                    </ModalBody>
                </ModalShell>
                {this.state.buttons}
            </div>
        );
    }
}

export default RegisterButton;